var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    [
      _c(
        "el-menu",
        {
          staticClass: "el-menu-demo",
          attrs: { "default-active": _vm.activeIndex, mode: "horizontal" },
          on: {
            select: function($event) {
              return _vm.handover($event)
            }
          }
        },
        [
          _c("el-menu-item", { attrs: { index: "ItemListN" } }, [
            _vm._v(_vm._s(_vm.$t("itemMapping")))
          ]),
          _c("el-menu-item", { attrs: { index: "goodsList" } }, [
            _vm._v(_vm._s(_vm.$t("itemType")))
          ])
        ],
        1
      ),
      _c("ItemListN", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.activeIndex == "ItemListN",
            expression: "activeIndex == 'ItemListN'"
          }
        ],
        ref: "ItemListN"
      }),
      _c("goodsList", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.activeIndex == "goodsList",
            expression: "activeIndex == 'goodsList'"
          }
        ],
        ref: "goodsList"
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }